<template>
  <div class="main-content sn-content">
  <!--  <el-card class="box-card clearfix">-->
      <el-row style="margin-bottom: 15px;background: #f4f4f5;padding: 15px 15px 0 0">
        <el-col :xs="12" :sm="16">
      <el-form class="search-form" ref="form" v-if="!$route.query.userId">
        <el-form-item label="状态：" label-width="85px">

          <el-select v-model="snStatus" placeholder="请选择状态" @change="statusChangeFn" size="small">
            <el-option v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="授权码：" label-width="85px">
          <el-input v-model="sn" clearable placeholder="请输入授权码" size="small"></el-input>
        </el-form-item>
        <el-form-item label="" label-width="85px">
          <el-button class="pxy-primary" size="small" @click="formSearch()">查询</el-button>
        </el-form-item>
      </el-form>
        </el-col>
        <el-col :xs="12" :sm="8" justify="end">
          <el-button type="text" @click="getDeletedSn()" style="color: grey;float: right;margin-top: -11px;margin-left: 10px">历史</el-button>
          <router-link v-if=" parseInt(userQuotaForSn) > parseInt(cloudSnCnt) " :to="{path:'/sn/add'}"
                     style="color: #FF6B00;float: right">
            去申请
          </router-link>
          <router-link :to="{path:'/price/index',query: {from: 'sn'} }"
                      style="marginRight:20px;color: #FF6B00;float: right">
            价格详情
          </router-link>

        </el-col>
      </el-row>
      <el-table
        :data="cloudSnList">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="授权码">
                <span>{{ props.row.sn }}</span>
              </el-form-item>
              <el-form-item label="标签">
                <span>{{ props.row.tag }}</span>
              </el-form-item>
              <el-form-item label="计费模式">
                <span v-if="props.row.chargeType == 2"> 按量付费</span>
                <span v-if="props.row.chargeType == 1"> 包月</span>
              </el-form-item>
              <el-form-item label="状态">
                <span class="danger" v-if="props.row.status == 1"> 无效</span>
                <span class="danger" v-if="props.row.deleted == 1"> 已删除</span>
                <span v-else-if="props.row.status == 0"> 有效</span>
              </el-form-item>


              <el-form-item label="授权类型">
                <span v-if="props.row.snType == 'B'"> 标准版</span>
                <span v-if="props.row.snType == 'C'"> 开发版</span>
              </el-form-item>
              <el-form-item label="最大并发数">
                <span>{{ props.row.maxConnCnt }}</span>
              </el-form-item>
              <el-form-item label="是否开启数据通道">
                <span v-if="props.row.dcsAuth == 'Y'"> 是</span>
                <span v-if="props.row.dcsAuth == 'N'"> 否</span>
              </el-form-item>
              <el-form-item label="是否开启互动模式">
                <span v-if="props.row.playModeAuth == 'Y'"> 是</span>
                <span v-if="props.row.playModeAuth == 'N'"> 否</span>
              </el-form-item>
              <el-form-item label="是否开启VR集中管控">
                <span v-if="props.row.vrRoomAuth== 'Y'"> 是</span>
                <span v-if="props.row.vrRoomAuth == 'N'"> 否</span>
              </el-form-item>
              <el-form-item label="是否开启开发版接口服务">
                <span v-if="props.row.snType== 'C'"> 是</span>
                <span v-if="props.row.snType == 'B'"> 否</span>
              </el-form-item>
              <el-form-item label="是否开启音频服务">
                <span v-if="props.row.audioInput== 'Y'"> 是</span>
                <span v-if="props.row.audioInput == 'N'"> 否</span>
              </el-form-item>
              <el-form-item label="是否开启视频服务">
                <span v-if="props.row.videoInput== 'Y'"> 是</span>
                <span v-if="props.row.videoInput == 'N'"> 否</span>
              </el-form-item>
              <el-form-item label="是否开启直播推流服务">
                <span v-if="props.row.liveStreaming == 'Y'"> 是</span>
                <span v-if="props.row.liveStreaming == 'N'"> 否</span>
              </el-form-item>
              <el-form-item label="是否开启虚拟驱动服务">
                <span v-if="props.row.audioDriver == 'Y'"> 是</span>
                <span v-if="props.row.audioDriver == 'N'"> 否</span>
              </el-form-item>
              <el-form-item label="是否是行业伙伴授权">
                <span v-if="props.row.wm == '3'"> 是</span>
                <span v-else> 否</span>
              </el-form-item>
             <!-- <el-form-item label="开始时间">
                <span> {{props.row.startDate | formatDate}}</span>
              </el-form-item>-->
              <el-form-item label="创建时间">
                <span> {{props.row.createDate | formatDate}}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>

        <template slot="empty">
          <el-button @click="gotoSnAdd()"
                     type="text"
                     size="small"
                     style="font-size:14px;color: #FF6B00">申请授权码
          </el-button>
        </template>
        <el-table-column
          prop="sn"
          label="授权码">
        </el-table-column>
        <el-table-column
          prop="tag"
          label="标签">
        </el-table-column>
        <el-table-column
          label="计费模式">
          <template slot-scope="scope">
            <span v-if="scope.row.chargeType == 2"> 按量付费</span>
            <span v-if="scope.row.chargeType == 1"> 包月</span>
          </template>
        </el-table-column>
        <el-table-column
          label="状态">
          <template slot-scope="scope">
            <span class="danger" v-if="scope.row.status == 1"> 无效</span>
            <span class="danger" v-if="scope.row.deleted == 1"> 已删除</span>
            <span v-else-if="scope.row.status == 0"> 有效</span>
          </template>
        </el-table-column>
        <el-table-column
          label="授权类型">
          <template slot-scope="scope">
            <span v-if="scope.row.snType == 'B'"> 标准版</span>
            <span v-if="scope.row.snType == 'C'"> 开发版</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="maxConnCnt"
          label="最大并发数">
        </el-table-column>
       <!-- <el-table-column
          label="开始时间">
          <template slot-scope="scope">
            <span> {{scope.row.startDate | formatDate}}</span>

          </template>
        </el-table-column>-->

        <el-table-column
          prop="createDate"
          label="创建时间">
          <template slot-scope="scope">
            {{scope.row.createDate | formatDate}}
          </template>
        </el-table-column>
        <el-table-column
          label="操作" width="120px"  >
          <template slot-scope="scope">
             <router-link
               v-if="scope.row.status == 0 && scope.row.deleted === 0 "
               class="router-link-btn "
               style="color: #FF6B00;font-size: 12px"
               :to="{ path: '/sn/update', query: { id: scope.row.id,redirect:'/sn/index',pPageNo:$refs.pageInfo.currentPage}}">
               更改配置
             </router-link>
            <el-popover
              v-if="scope.row.status == 0 && scope.row.deleted === 0 "
              placement="top-start"
              width="200"
              trigger="hover"
              content="删除授权码后，使用该授权码的平台将停止服务，请谨慎删除操作">
              <el-button slot="reference" class="router-link-btn "
                         style="color: #FF6B00;"  type="text" size="mini" @click="deleteSn(scope.row)">删除授权码</el-button>
            </el-popover>
            <el-popover
              v-if="scope.row.status == 0 && scope.row.deleted === 0 "
              placement="top-start"
              width="200"
              trigger="hover"
              content="授权码使用后，是与机器绑定的，如果需要更换机器，需要在此处重置授权码。注意：确保只有一个集群在使用该授权，之前使用该授权码的服务必须停掉">
              <el-button slot="reference" class="router-link-btn "
                         style="color: #FF6B00;"  type="text" size="mini" @click="resetSn(scope.row)">重置授权码</el-button>
            </el-popover>

            <el-button    v-if="scope.row.status == 1 || scope.row.deleted == 1" slot="reference" class="router-link-btn "
                       style="color: #FF6B00;"  type="text" size="mini" @click="openOperaLog(scope.row.sn)">操作履历</el-button>
          </template>
        </el-table-column>

      </el-table>
      <el-row type="flex" justify="space-between" style="align-items: center;">
        <template v-if="$store.state.voucherBalance && $store.state.voucherBalance != ''">
          <p v-if="userBalance <= 0 && (!$store.state.voucherBalance>0)" class="balance-tip">温馨提示：您的余额不足，为了不影响您的使用，请及时充值。
            <router-link :to="{path:'/account/charge'}" style="color: #F56C6C;">
              【去充值】
            </router-link>
          </p>
          <div v-else></div>
        </template>
        <template v-else>
          <p v-if="userBalance <= 0" class="balance-tip">温馨提示：您的余额不足，为了不影响您的使用，请及时充值。
            <router-link :to="{path:'/account/charge'}" style="color: #F56C6C;">
              【去充值】
            </router-link>
          </p>
          <div v-else></div>
        </template>
        <PageComponent ref="pageInfo"></PageComponent>
      </el-row>

    <!--</el-card>-->

    <el-dialog title="更新履历" :visible.sync="dialogTableVisible">
      <el-table :data="cloudSnOperaLogList">
        <el-table-column prop="note" label="更新说明" ></el-table-column>
        <el-table-column label="更新时间">
          <template slot-scope="scope">
            <span> {{scope.row.createDate | formatDate}}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
  import {Message} from "element-ui";
  import PageComponent from '@/components/pageInfo/PageComponent'

  export default {
    components: {PageComponent},
    data() {
      return {
        cloudSnList: [],
        cloudSnCnt: 0,
        userQuotaForSn: {},
        snStatus: 0,
        sn:'',
        // 状态下拉列表
        statusOptions: [
          {value: '', label: '全部'},
          {value: 0, label: '有效'},
          {value: 1, label: '禁用'},
        ],
        deleted: 0,
        dialogTableVisible:false,
        cloudSnOperaLogList:[],
      }
    },
    created() {
      if(window.location.search.indexOf('?utm_source=weixinsaoma')>-1) {
        window.location.search = '';
      }
    },
    computed: {
      user() {
        return this.$store.state.user;
      },
      userBalance(){
        return this.$store.state.userBalance;
      }
    },
    methods: {
      getCloudSn: function () {
        var params = {};
        params.userId = this.$store.state.user.userId;
        params.page = this.$refs.pageInfo.currentPage;
        params.pageSize = 10;
        if(this.snStatus !=="") params.status = this.snStatus;//状态筛选
        if(this.sn !=="") params.sn = this.sn;//状态筛选
        params.deleted = this.deleted;
        this.getRequest('/pocCloudSn/list', params).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.cloudSnList = resp.data.result.records;
              console.log(this.cloudSnList)
              this.cloudSnCnt = resp.data.result.total;
              this.$refs.pageInfo.outputPagenator(resp.data.result.total, resp.data.result.size);
              //TODO:查询poc_product表查询具体的配合信息
            } else {
              Message.error(resp.data.message);
            }
          }
        })
      },
      // 查询状态change
      statusChangeFn(val) {
        this.snStatus = val;
        this.deleted = 0;
        let queryStr = JSON.parse(JSON.stringify(this.$route.query));
        queryStr.page = 1;
        this.$router.push({query: queryStr});
        this.getCloudSn();
      },
      getUserQuota: function () {
        this.getRequest('/uacUserConfig/getInfo', {"userId": this.$store.state.user.userId}).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
                  this.userQuotaForSn = resp.data.result.snQuota;
            } else {
              Message.error(resp.data.message);
            }
          }
        })
      },
      gotoSnAdd() {
        if(parseInt(this.userBalance) < 0){
          this.$confirm('余额不足，无法创建授权码，请选择"去充值"。如果想获取额外支持，拨打热线电话：4006781024', '温馨提示', {
            confirmButtonText: '去充值',
            cancelButtonText: '关闭',
            type: 'warning',
            center: true
          }).then(() => {
            this.$router.push({path: '/account/charge'})
          }).catch(() => {

          });
        }else {
          this.$router.push({path: '/sn/add'})
        }
      },
      resetSn(row) {
        var _this = this;
        var params = {};
        params.sn = row.sn;
        params.id = row.id;
        this.postRequestJson('/pocCloudSn/reset', JSON.stringify(params)).then(resp => {
          _this.loading = false;
          if (resp && resp.status == 200) {
            var data = resp.data;
            if (data.code == 1000) {
              Message.success(data.message);
            } else {
              Message.error(data.message);
            }
          }
        });
      },
      deleteSn(row) {
        var _this = this;
        var params = {};
        params.sn = row.sn;
        params.id = row.id;
        _this.$confirm('是否删除【'+row.sn +'】授权码？', "提示", {
          confirmButtonText: "是",
          cancelButtonText: "取消",
          type: 'warning'
        }).then(() => {
        this.postRequestJson('/pocCloudSn/delete', JSON.stringify(params)).then(resp => {
          _this.loading = false;
          if (resp && resp.status == 200) {
            var data = resp.data;
            if (data.code == 1000) {
              this.getCloudSn()
              Message.success(data.message);
            } else {
              Message.error(data.message);
            }
          }
        });
        }).catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      getDeletedSn(){
        this.deleted = 1;
        this.snStatus = "";
        this.getCloudSn()
      },
      formSearch(){
        this.deleted = 0;
        this.getCloudSn()
      },
      openOperaLog(sn){
        this.getRequest('/pocCloudsnOperaLog/list', {"sn":sn}).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.cloudSnOperaLogList = resp.data.result;
              this.dialogTableVisible = true
            } else {
              Message.error(resp.data.message);
            }
          }
        })
      }
    },
    mounted: function () {
      this.getCloudSn();
      this.getUserQuota();
      this.$refs.pageInfo.initPagenator(this.getCloudSn, null);
    },
    beforeDestroy() {

    }
  }
</script>
<style>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 180px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: calc(50% - 50px);
    margin-left: 50px;
  }
  .balance-tip {
    color:#F56C6C;
  }
</style>
